var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.456 2.75867C14.415 2.81267 14.886 2.95467 15.32 3.72667C15.772 4.49767 16 5.82567 16 8.16467V8.16767V8.17267C16 10.5007 15.772 11.8387 15.321 12.6017C14.887 13.3737 14.416 13.5137 13.457 13.5787C12.498 13.6337 10.089 13.6667 8.002 13.6667C5.911 13.6667 3.501 13.6337 2.543 13.5777C1.586 13.5127 1.115 13.3727 0.677 12.6007C0.23 11.8377 0 10.4997 0 8.17167V8.16967V8.16667V8.16367C0 5.82567 0.23 4.49767 0.677 3.72667C1.115 2.95367 1.587 2.81267 2.544 2.75767C3.501 2.69367 5.911 2.66667 8.002 2.66667C10.089 2.66667 12.498 2.69367 13.456 2.75867ZM11 8.16667L6 5.16667V11.1667L11 8.16667Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.41d725f88f3fdc2df676a30f9bcc6d16.svg";
export { ForwardRef as ReactComponent };